import { render } from "./Paypage.vue?vue&type=template&id=a4820b82&scoped=true"
import script from "./Paypage.vue?vue&type=script&lang=js"
export * from "./Paypage.vue?vue&type=script&lang=js"

import "./Paypage.vue?vue&type=style&index=0&id=a4820b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4820b82"]])

export default __exports__